<template>
  <div>
    <div style="display: none">
      <slot></slot>
    </div>
    <div>Pomyślnie wylogowano</div>
  </div>
</template>

<script>
import wnbAddress from "../wnbAddresses";

export default {
  name: "LogoutView",
  data: () => ({
    valid: false,
    company: "",
    login: "",
    password: "",

    companyRules: [v => !!v || "Firma nie może pozostać bez wartości."],
    loginRules: [v => !!v || "Login nie może pozostać bez wartości."],
    passwordRules: [v => !!v || "Hasło nie może pozostać bez wartości."]
  }),
  computed: {
    user_id: function() {
      if (this.$store.getters.userProperties != null) {
        return this.$store.getters.userProperties.name;
      }
      return "Niezalogowany";
    }
  },
  methods: {
    logoutClick: function() {
      //this.$auth.dispatch('login', { user })
      this.$store.dispatch("AUTH_LOGOUT").then(() => {
        this.$router.push("/login");
        alert("Wylogowano");
      });
    }
  },
  mounted: function() {
    this.$nextTick(() => {
      this.$store.dispatch("AUTH_LOGOUT").then(() => {
        let externalLogout = false;
        if (document.referrer.length > 0) {
          const urlHelperHostname = new URL(window.location.href).hostname;
          const urlHelperReferrerHostname = new URL(document.referrer).hostname;
          if (urlHelperHostname !== urlHelperReferrerHostname) {
            externalLogout = true;
          }
        }
        if (this.$store.getters["isWnbUser"] || externalLogout) {
          window.location.href = wnbAddress("LOGOUT");
        } else {
          this.$router.replace("/login");
          //alert("Wylogowano");
        }
      });
    });
  }
};
</script>

<style scoped></style>
